import { useEffect, useRef, useState } from 'react'
import { Checkbox, Col, Input, Row } from 'antd'
import { useDispatch, useSelector } from 'react-redux'

export default ({ idField, items, onFilter, updateFilters }) ->
  filterInputRef = useRef(undefined)
  dispatch = useDispatch()

  isIndeterminate = (
    enabledCount = _.filter(items, (item) -> item.enabled).length
    enabledCount isnt _.size(items) and enabledCount isnt 0
  )

  activeFilterTab = useSelector((state) ->
    state.graphFilter.activeFilterTab
  )

  onCheck = ({ target: { checked }}) ->
    dispatch(updateFilters(_.keyBy(_.map(items, (item) ->
      { item..., enabled: checked }
    ), idField)))

  <Row type="flex" gutter={8} align="middle" style={{ marginBottom: '8px', paddingBottom: '8px' }}>
    <Col>
      <Checkbox onChange={onCheck}
                checked={not _.find(items, (item) -> not item.enabled)}
                indeterminate={isIndeterminate} />
    </Col>
    <Col style={{ flex: 'auto' }}>
      <Input size="small"
             ref={filterInputRef}
             tabIndex={2}
             onChange={({ target: { value }}) ->
               onFilter(value)
             }
             placeholder="Filter" />
    </Col>
  </Row>
